import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { List } from '@mic3/platform-ui';
import Icon from 'app/components/atoms/Icon/Icon';
import { OPERATORS } from '../GlobalSearchModal.constants';
import {
    SectionTitle,
    StyledListItem,
    StyledListItemIcon,
    StyledListItemText,
} from '../GlobalSearchModal.styles';

const OperatorList = ({ filterName, searchQuery, onOperatorClick, highlightedIndex, operators }) => {
    const highlightedRef = useRef(null);
    const operatorList = operators || OPERATORS;

    const filteredOperators = searchQuery.trim()
        ? operatorList.filter(
            (op) =>
                op.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
                op.symbol.includes(searchQuery)
        )
        : operatorList;
    
    // Auto-scroll to highlighted item
    useEffect(() => {
        if (highlightedRef.current) {
            highlightedRef.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }, [highlightedIndex]);
    
    return (
        <>
            <SectionTitle variant="caption">
                Select operator for {filterName}
            </SectionTitle>
            <List>
                {filteredOperators.map((operator, index) => {
                    const isHighlighted = highlightedIndex === index;
                    return (
                        <StyledListItem
                            key={index}
                            ref={isHighlighted ? highlightedRef : null}
                            button
                            onClick={() => onOperatorClick(operator.symbol)}
                            $highlighted={isHighlighted}
                        >
                            <StyledListItemIcon>
                                <Icon name={operator.icon} size="sm" />
                            </StyledListItemIcon>
                            <StyledListItemText primary={operator.label} />
                        </StyledListItem>
                    );
                })}
            </List>
        </>
    );
}

OperatorList.propTypes = {
    filterName: PropTypes.string.isRequired,
    searchQuery: PropTypes.string,
    onOperatorClick: PropTypes.func.isRequired,
    highlightedIndex: PropTypes.number,
    operators: PropTypes.arrayOf(PropTypes.shape({ symbol: PropTypes.string, label: PropTypes.string, icon: PropTypes.string })),
};

OperatorList.defaultProps = {
    searchQuery: '',
    highlightedIndex: -1,
    operators: null,
};

export default OperatorList;

